import React, { useContext, useEffect } from 'react';
import './InvQuoteView.css';
import { baseUrl_SPB } from '../BaseUrl';
import { useAuth } from '../AuthProvider';
import { fetchAuthSession } from 'aws-amplify/auth';
import { usePDF } from 'react-to-pdf';

const InvQuoteView = (props) => {
    const [companyName, setCompanyName] = React.useState('');
    const [companyABN, setCompanyABN] = React.useState('');
    const [companyAddress, setCompanyAddress] = React.useState('');
    const [bsbNumber, setBsbNumber] = React.useState('');
    const [accountNumber, setAccountNumber] = React.useState('');
    const [bankName, setBankName] = React.useState('');
    const [customerName, setCustomerName] = React.useState('');
    const [type, setType] = React.useState('');
    const [customerEmail, setCustomerEmail] = React.useState('');
    const [brandImageUrl, setBrandImageUrl] = React.useState('');
    const [checkoutUrl, setCheckoutUrl] = React.useState('');
    const [invoiceNumber, setInvoiceNumber] = React.useState('');
    const [issueDate, setIssueDate] = React.useState('');
    const [dueDate, setDueDate] = React.useState('');
    const [items, setItems] = React.useState([]);
    const [paymentRecords, setPaymentRecords] = React.useState([]);
    const authContext = useAuth();
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const calculateSubtotal = () => {
        return items.reduce((acc, item) => acc + item.quantity * item.unitPrice, 0);
    };

    const calculateTotalPaid = () => {
        console.log(paymentRecords);
        return paymentRecords.reduce((sum, item) => sum + parseFloat(item.amount), 0);
    };

    const calculateTotalGST = () => {
        return calculateSubtotal() * 0.10;
    };

    const calculateAmountDue = () => {
        return calculateSubtotal() + calculateTotalGST() - calculateTotalPaid();
    };

    const processUnitPrice = (unitPrice) => {
        const parsedPrice = parseFloat(unitPrice);
        return isNaN(parsedPrice) ? 0 : parsedPrice.toFixed(2);
    };


    const processItems = (items) => {

        return items.map(item => {
            const quantity = parseInt(item.quantity ? item.quantity : 0);

            const unitPrice = parseInt(item.price ? item.price : 0);

            const amount = (quantity * unitPrice);

            return {
                ...item,
                quantity,
                unitPrice,
                amount
            };
        });
    };
    const processPaymentItems = (items) => {
        return items.map(item => {
            return {
                ...item
            };
        });
    };
    useEffect(() => {
        console.log('We stest strip');
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const iqId = urlParams.get('id');
        fetchAuthSession().then((session) => {


            fetch(`${baseUrl_SPB}/viewiq/getsingleinvquote?id=` + iqId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log('brandimage', data);
                    setBrandImageUrl(data.company && data.company.brandImageUrl ? data.company.brandImageUrl : '');
                    setCustomerName(data.customerName);
                    setCustomerEmail(data.customerEmail);
                 

                    setCompanyName(data.company && data.company.companyName ? data.company.companyName : '');
                    setCompanyABN(data.company && data.company.companyABN ? data.company.companyABN : '');
                    setCompanyAddress(data.company && data.company.companyAddress ? data.company.companyAddress : '');
                    setBsbNumber(data.company && data.company.bankDetails && data.company.bankDetails.length > 0 ? data.company.bankDetails[0].bsbNumber : '');
                    setAccountNumber(data.company && data.company.bankDetails && data.company.bankDetails.length>0 ? data.company.bankDetails[0].accountNumber : '');
                    setBankName(data.company && data.company.bankDetails && data.company.bankDetails.length > 0 ? data.company.bankDetails[0].bankName : '');
                    setCustomerName(data.customerName);
                    setCustomerEmail(data.customerEmail);
                    setInvoiceNumber(data.invoiceOrQuoteNumber);
                    setIssueDate(data.dated);
                    setDueDate(data.dueDate);
                    setType(data.type);
                    setItems(processItems(data.invOrQuoteItems));
                    console.log('testing stripe');
                    setPaymentRecords(processPaymentItems(data.invPaymentItems));
                    console.log('testing stripe');
                    /*fetch(`${baseUrl_SPB}/invoice/checkout/create-checkout-session`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',

                        },
                        body: JSON.stringify({
                            productId: data.invoiceOrQuoteNumber,
                            productName: data.invoiceOrQuoteNumber,
                            dynamoDbInvoiceId: data.id,
                            companyName: data.companyName,
                            amount: calculateAmountDue(),
                            customerName: data.customerName,
                            customerEmail: data.customerEmail,
                            issueDate: data.dated,
                        })
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log('testing stripe2');
                            setCheckoutUrl(data.urlProcess);
                        })
                        .catch(error => console.error('Error fetching invoice quote:', error));*/
                })
                .catch(error => console.error('Error fetching invoice quote:', error));
        });
    }, []);


    const pay20 = () => {
        alert("Pay 20% of the invoice");
    }
    const payfull = () => {
        console.log(checkoutUrl);
        window.location.href = checkoutUrl;

    }
    const [brandImageBase64, setBrandImageBase64] = React.useState('');

    const convertImageToBase64 = async (imageUrl) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
                setBrandImageBase64(reader.result);
            };
            reader.readAsDataURL(blob);
        } catch (error) {
            console.error('Error converting image to base64:', error);
        }
    };

    useEffect(() => {
        if (brandImageUrl) {
            convertImageToBase64(brandImageUrl);
        }
    }, [brandImageUrl]);

    return (
        <div>
            <div ref={targetRef}>
                <div className="invoice-container">
                    <div className="invoice-header">
                        <div className="invoice-brand">
                            {brandImageBase64 && <img src={brandImageBase64} alt="Brand Logo" className="brand-logo" style={{ height: '70px', width: '70px' }} />}
                        </div>
                        <div className="invoice-from">
                            <div><strong>From:</strong> </div>
                            <div> {companyName}</div>
                            <div> {companyABN}</div>
                            <div>{companyAddress}</div>
                            <strong></strong> 
                        </div>
                        <div className="invoice-to">
                            <strong>To:</strong> {customerName}
                        </div>
                        <div className="invoice-number">
                            <strong>{type === 'quote' ? 'Quote' : 'Invoice'} Number:</strong> {invoiceNumber}
                        </div>
                        <div className="invoice-dates">
                            <div><strong>Issue Date:</strong> {issueDate}</div>
                            <div><strong>Due Date:</strong> {dueDate}</div>
                        </div>
                    </div>
                    <table className="invoice-table">
                        <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                <th>GST</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.quantity}</td>
                                    <td>${processUnitPrice(item.unitPrice)}</td>
                                    <td>{item.gst ? 'Inclusive' : 'Exclusive'}</td>
                                    <td>${item.amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="invoice-summary">
                        <div className="subtotal">
                            <strong>Subtotal:</strong> ${calculateSubtotal().toFixed(2)}
                        </div>
                        <div className="total-gst">
                            <strong>Total GST 10%:</strong> ${calculateTotalGST().toFixed(2)}
                        </div>
                        <div className="amount-due">
                            <strong>Total paid:</strong> ${calculateTotalPaid().toFixed(2)}
                        </div>
                        <div className="amount-due">
                            <strong>Amount Due:</strong> ${calculateAmountDue().toFixed(2)}
                        </div>
                    </div>
                    <div className='payment-info'>
                        <div>
                            Payment information:
                        </div>
                        <div>{companyName}</div>
                        <div>{bankName}</div>
                        <div>{bsbNumber}</div>
                        <div>{accountNumber}</div>


                    </div>
                </div>

            </div>
            <div className="invoice-actions">
                <button className="action-button" onClick={() => toPDF()}>Download {type}</button>
                {/*<button className="action-button" onClick={() => payfull(checkoutUrl)}>Pay in Full</button>*/}
            </div>
        </div>
    );
};

export default InvQuoteView;